const DOCUMENT = 'NEW_ACCREDITATION_';

const actions = {
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  ADD: DOCUMENT + 'ADD',
  EDIT: DOCUMENT + 'EDIT',
  CANCEL: DOCUMENT + 'CANCEL',
  TOUCH: DOCUMENT + 'TOUCH',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CHANGE_NESTED_PROPERTY: DOCUMENT + 'CHANGE_NESTED_PROPERTY',
  CREATE: DOCUMENT + 'CREATE',
  CHANGE_PROPERTIES: DOCUMENT + 'CHANGE_PROPERTIES',
  SEND_REQUEST: DOCUMENT + 'SEND_REQUEST',
  UPDATE_DEFAULT: DOCUMENT + 'UPDATE_DEFAULT',
  LOAD_DATA: DOCUMENT + 'LOAD_DATA',
  LOAD_DATA_SUCCESS: DOCUMENT + 'LOAD_DATA_SUCCESS',
  SAVE: DOCUMENT + 'SAVE',

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  changeNestedProperty: data => ({
    type: actions.CHANGE_NESTED_PROPERTY,
    payload: data,
  }),

  changeProperties: data => ({
    type: actions.CHANGE_PROPERTIES,
    payload: data,
  }),

  create: () => ({
    type: actions.CREATE,
  }),

  updateDefault: () => ({
    type: actions.UPDATE_DEFAULT,
  }),

  saveSuccess: () => ({
    type: actions.SAVE_SUCCESS,
  }),

  saveError: data => ({
    type: actions.SAVE_ERROR,
    payload: data,
  }),

  add: data => ({
    type: actions.ADD,
    payload: data,
  }),

  edit: data => ({
    type: actions.EDIT,
    payload: data,
  }),

  cancel: () => ({
    type: actions.CANCEL,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),

  loadFormData: data => ({
    type: actions.LOAD_FORM_DATA,
    payload: data,
  }),

  loadFormDataSuccess: data => ({
    type: actions.LOAD_FORM_DATA_SUCCESS,
    payload: data,
  }),

  save: data => ({
    type: actions.SAVE,
    payload: data,
  }),

  loadData: data => ({
    type: actions.LOAD_DATA,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_DATA_SUCCESS,
    payload: data,
  }),
};

export default actions;
